var path = 'ui-formly/types/select/index.html';
var html = "<select class=\"form-control\" ng-model=\"model[options.key]\"></select>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;